import React from "react";
import AllowLocation from "../../AllowLocation/AllowLocation";
import LocationOutOfBounds from "../../LocationOutOfBounds/LocationOutOfBounds";
import AgeRestrictionModal from "../../AgeRestrictionModal/AgeRestrictionModal";
import DobModal from "../../DobModal/DobModal";
import SelectCurrencyModal from "../SelectCurrencyModal/SelectCurrencyModal";
import AllowLocationManually from "../../AllowLocationManually/AllowLocationManually";
import { TopupFlowProps } from "./types";

export default function TopupFlow(props: TopupFlowProps) {
  const {
    handleTopup,
    handleGetDeviceLocationInfo,
    isSelectCurrencyOpen,
    closeSelectCurrency,
    isAgeRestrictionOpen,
    closeAgeRestriction,
    isDobModalOpen,
    closeDobModal,
    isAllowLocationPromptOpen,
    closeAllowLocationPrompt,
    isAllowLocationManuallyOpen,
    openAllowLocationManually,
    closeAllowLocationManually,
    isLocationOutOfBoundsOpen,
    closeLocationOutOfBounds,
    ipLocationCountry,
  } = props;

  return (
    <>
      {isSelectCurrencyOpen && (
        <SelectCurrencyModal
          isOpen={isSelectCurrencyOpen}
          onClose={closeSelectCurrency}
          handleSuccess={(updatedCurrency) => handleTopup({ updatedCurrency })}
        />
      )}

      <AgeRestrictionModal
        isOpen={isAgeRestrictionOpen}
        onClose={closeAgeRestriction}
        toastMessage="Ineligible to top-up HPR"
      />
      <DobModal
        isOpen={isDobModalOpen}
        onClose={closeDobModal}
        handleSuccess={(updatedDob) => handleTopup({ updatedDob })}
      />

      <AllowLocation
        isOpen={isAllowLocationPromptOpen}
        onClose={closeAllowLocationPrompt}
        handleDeviceLocationCheck={handleGetDeviceLocationInfo}
        openAllowLocationManually={openAllowLocationManually}
      />
      <AllowLocationManually
        isOpen={isAllowLocationManuallyOpen}
        onOpen={openAllowLocationManually}
        onClose={closeAllowLocationManually}
        handleDeviceLocationCheck={handleGetDeviceLocationInfo}
      />
      <LocationOutOfBounds
        countryCode={ipLocationCountry}
        isOpen={isLocationOutOfBoundsOpen}
        onClose={closeLocationOutOfBounds}
      />
    </>
  );
}
